import { useMemo } from "react";

import { players } from "@/helpers/formatters";
import { cn } from "@/lib/utils";

import { GameKindEnum } from "../../types";
import { DifficultyIcon, MinutesIcon, PlayersIcon, VirtualIcon } from "./icons";

const KEY_TO_ICON: Record<string, React.ReactNode> = {
  difficulty: <DifficultyIcon />,
  kind: <VirtualIcon />,
  minutes: <MinutesIcon />,
  players: <PlayersIcon />,
};

interface PropertiesGameType {
  difficulty?: string;
  kind: GameKindEnum;
  minutes?: number;
  playersMax: number;
  playersMin: number;
}

interface PropertiesProps {
  className?: string;
  game: PropertiesGameType;
}

export default function Properties({ className, game }: PropertiesProps) {
  const entries = useMemo(() => {
    const items: Record<string, string> = {};

    const playersString = players(game.playersMin, game.playersMax);

    if (playersString !== "") {
      items.players = playersString;
    }
    if (game.minutes) {
      items.minutes = `${game.minutes} mins`;
    }
    if (game.kind === GameKindEnum.VER) {
      items.kind = "Virtual";
    }
    if (game.difficulty && game.difficulty !== "Unknown") {
      items.difficulty = game.difficulty;
    }

    return Object.entries(items);
  }, [game]);

  if (!entries.length) {
    return null;
  }

  return (
    <ul className={cn("flex flex-wrap gap-[5px]", className)}>
      {entries.map(([key, value]) => (
        <li
          className="flex h-6.5 items-center gap-1 rounded-[3px] bg-white/10 px-[7px]"
          key={key}
        >
          {key in KEY_TO_ICON && KEY_TO_ICON[key]}
          <p className="text-12 text-white">{value}</p>
        </li>
      ))}
    </ul>
  );
}
